import { calcDocument, formatMoney } from '@makila/fiscal';
import { billableItems, type Order, type OrderItem, orderLines } from '@makila/pos-core';
import { mzDateTime, esc } from './receipt';

const head = (title: string) => `<!doctype html><html lang="pt"><head><meta charset="utf-8"><title>${esc(title)}</title><style>
  @page { size: 80mm auto; margin: 0; } * { box-sizing: border-box; }
  body { margin: 0; padding: 3mm 4mm; width: 80mm; font: 12px/1.35 ui-monospace, "Courier New", monospace; color: #000; }
  h1 { font-size: 16px; margin: 0 0 2px; } h2 { font-size: 14px; margin: 8px 0 2px; border-top: 1px dashed #000; padding-top: 4px; }
  .big { font-size: 15px; font-weight: bold; } .note { padding-left: 6mm; font-style: italic; } .r { text-align: right; } table { width: 100%; border-collapse: collapse; }
  .warn { margin-top: 6px; border: 1px solid #000; padding: 3px; text-align: center; font-weight: bold; }
</style></head><body>`;

const itemLine = (i: OrderItem) => `<div class="big">${esc(i.quantity.replace('.', ','))} × ${esc(i.description)}</div>`
  + (i.modifiers.length ? `<div class="note">${i.modifiers.map((m) => esc(m.name)).join(', ')}</div>` : '')
  + (i.note ? `<div class="note">» ${esc(i.note)}</div>` : '');

/** Talão da cozinha/bar: os itens que acabaram de ser enviados, por estação. Não é documento fiscal. */
export function kitchenTicketHtml(o: Order, groups: { station: string; items: OrderItem[] }[], waiter: string): string {
  return head(`Pedido ${o.label}`) + `<h1>${esc(o.label)}</h1><div>${mzDateTime(new Date().toISOString())} · ${esc(waiter)}${o.guests ? ` · ${o.guests} pessoas` : ''}</div>`
    + (o.delivery ? `<div class="warn">ENTREGA — ${esc(o.delivery.address)}${o.delivery.phone ? ` · ${esc(o.delivery.phone)}` : ''}</div>` : '')
    + groups.map((g) => `<h2>${esc(g.station.toUpperCase())}</h2>${g.items.map(itemLine).join('')}`).join('')
    + '</body></html>';
}

/**
 * Consulta de mesa (pré-conta): o que está por pagar, para o cliente ver antes de
 * pagar. NÃO é factura nem talão de venda — diz isso no papel.
 */
export function preBillHtml(o: Order, company: string): string {
  const lines = orderLines(o);
  const t = lines.length ? calcDocument({ lines }) : null;
  const rows = billableItems(o).map((i, k) => `<tr><td>${esc(i.quantity.replace('.', ','))} × ${esc(lines[k]!.description)}</td><td class="r">${t ? formatMoney(t.lines[k]!.totalAmount) : ''}</td></tr>`).join('');
  return head(`Consulta ${o.label}`) + `<h1>${esc(company)}</h1><div>${esc(o.label)} · ${mzDateTime(new Date().toISOString())}</div>`
    + `<table style="margin-top:6px">${rows}<tr><td class="big">Total</td><td class="r big">${formatMoney(t?.grossTotal ?? '0')} MT</td></tr></table>`
    + '<div class="warn">CONSULTA DE MESA — NÃO SERVE DE FACTURA</div></body></html>';
}
